if (document.querySelector(".js-manual-replies #content-renderer") != null) {
  import("@a-world-for-us/elearning_content_editor").then(async ({ ComponentsRenderer }) => {
    const { gql } = await import("@apollo/client/core");
    const { default: initApolloClient } = await import("../apollo/graphql_client");

    const token = $("#content-renderer").data("token");
    const client = initApolloClient(token);

    const containerId = "content-renderer";
    const $params = $(`#${containerId}`);
    const payload = $params.data("editable-components");

    const parentType = $params.data("parent-type");
    const parentId = $params.data("parent-id");

    const answererType = $params.data("answerer-type");
    const answererId = $params.data("answerer-id");

    const subjectType = $params.data("subject-type");
    const subjectId = $params.data("subject-id");

    const usersParams = {
      [_.camelCase(answererType) + "Id"]: answererId,
      [_.camelCase(subjectType) + "Id"]: subjectId,
    };

    const sendQuizReplyMutation = gql`
      mutation (
        $id: ID!
        $traineeId: ID
        $companyId: ID
        $instructorId: ID
        $fundingAgencyId: ID
        $answer: String
        $rate: Int
        $singleChoiceAnswer: QuizTestReplyInput
        $multipleChoiceAnswers: [QuizTestReplyInput]
        $fillInTheBlankAnswer: QuizFillInTheBlankReplyInput
        $matrixAnswers: [QuizMatrixReplyInput]
        $matchingPairsAnswers: [QuizMatchingPairsReplyInput]
      ) {
        create_quiz_reply(
          editable_component_id: $id
          trainee_id: $traineeId
          company_id: $companyId
          instructor_id: $instructorId
          funding_agency_id: $fundingAgencyId
          quizFreeTextReply: { answer: $answer }
          quizStarsRatingReply: { rate: $rate }
          quizOutOfTenReply: { rate: $rate }
          quizSingleChoiceReply: $singleChoiceAnswer
          quizMultipleChoiceReplies: $multipleChoiceAnswers
          quizMatrixReplies: $matrixAnswers
          quizFillInTheBlankReply: $fillInTheBlankAnswer
          quizMatchingPairsReplies: $matchingPairsAnswers
        ) {
          is_verifiable
          validation {
            ... on QuizReplyValidation {
              is_correct
              raw_correction
            }
            ... on QuizMatchingPairsReplyValidation {
              is_correct
              evaluated_replies {
                answer_id
                proposition_id
                is_correct
              }
            }
          }
        }
      }
    `;

    const setEvaluationReadMutation = gql`
      mutation ($id: ID!, $traineeId: ID, $companyId: ID, $instructorId: ID, $fundingAgencyId: ID) {
        set_evaluation_read(
          id: $id
          trainee_id: $traineeId
          company_id: $companyId
          instructor_id: $instructorId
          funding_agency_id: $fundingAgencyId
        )
      }
    `;

    const sendQuizAnswer = (id, reply) => {
      return client.mutate({ mutation: sendQuizReplyMutation, variables: Object.assign({}, usersParams, reply, { id }) });
    };

    function markSelectedTraineeAsWithReponse() {
      // legacy
      const subjectLabel = document.getElementById(`subject-${subjectId}`);
      subjectLabel?.classList.add("has-answer");

      // design v2
      document.getElementById(`${subjectId}-icon-user-absent`)?.classList.add("has-hidden");
      document.getElementById(`${subjectId}-icon-checkmark`)?.classList.remove("has-hidden");
    }

    const setEvaluationRead = (parentId, usersParams) => {
      client.mutate({ mutation: setEvaluationReadMutation, variables: Object.assign({}, usersParams, { id: parentId }) });
    };

    ComponentsRenderer.init({
      elementId: containerId,
      componentsPayload: payload,
      shouldTrackProgress: true,
      showProgress: false,
      onComponentRead: () => {},
      onContentRead: () => {
        if (parentType == "evaluation") setEvaluationRead(parentId, usersParams);
        markSelectedTraineeAsWithReponse();
      },
      config: {
        isReplayable: true,
        sendQuizAnswer,
      },
    });
  });
}
